import axios from '../globals/axios/axios.index';

export interface BookContent {
  id: number;
  title: string;
}

export interface BookContentDetail extends BookContent {
  id: number;
  title: string;
  description: string;
  images?: string;
}

export const getAllBookContents = async (): Promise<BookContent[]> => {
  const response = await axios.get('/api/v1/book/book-content/');
  return response.data;
};

export const getBookContentById = async (id: number): Promise<BookContentDetail> => {
  const response = await axios.get(`/api/v1/book/book-content/${id}/`);
  return response.data;
};
